import { parseDecimalNumber } from "./number";

export function parseWeightKg(value: unknown): number | undefined {
  return parseDecimalNumber(value);
}

export function normalizeWeightKgForPayload(
  value: unknown,
): number | undefined {
  const weightKg = parseWeightKg(value);
  if (weightKg == null || weightKg <= 0) return undefined;
  return weightKg;
}

/** The first usable weight among the candidates, in order of preference. */
export function resolvePetFormWeightKg(
  ...candidates: unknown[]
): number | undefined {
  for (const candidate of candidates) {
    const weightKg = normalizeWeightKgForPayload(candidate);
    if (weightKg !== undefined) return weightKg;
  }
  return undefined;
}
